<template>
    <div class="body-category">
        <CategoryManage v-if="categoryState"
                        @closeEvent="switchCategory"/>
        <div class="text-title">分类列表</div>
        <ul class="items-category">
            <li class="select-item my-cursor"
                @click.stop="setCategoryItem(item)"
                v-for="(item) in categoryItems">
                <div class="text-name">{{ item.title }}</div>
                <div class="icon-select my-cursor" v-show="item.categoryId === categoryShowId"></div>
            </li>
            <li class="select-item my-cursor"
                @click.stop="setCategoryItem(item)"
                v-for="(item) in tbListCategory">
                <div class="text-name">{{ item.title }}</div>
                <div class="icon-select my-cursor" v-show="item.categoryId === categoryShowId"></div>
            </li>
        </ul>
        <div class="button-category my-cursor" @click.stop="switchCategory()">分类管理</div>
    </div>
</template>

<script>
import CategoryManage from "../CategoryManage";
import { mapState, mapMutations } from "vuex";
export default {
    name: "Category",
    components: {
        CategoryManage
    },
    data(){
        return {
            categoryState: false,
            categoryItems: [
                {
                    categoryId: "all",
                    title: "全部",
                },{
                    categoryId: "",
                    title: "无分类",
                },
            ],
            selectId: "all",
        }
    },
    computed: {
        ...mapState("listModules", {
            tbListCategory: state => state.tbListCategory,
            categoryShowId: state => state.categoryShowId,
        }),
    },
    methods: {
        ...mapMutations("listModules", ["setCategoryShowId"]),
        /**
         * 分类管理 开/关
         */
        switchCategory: function(){
            this.categoryState = !this.categoryState;
        },

        setCategoryItem: function(categoryItem){
            if(categoryItem.categoryId !== this.categoryShowId){
                this.setCategoryShowId(categoryItem.categoryId);
                this.$emit("submitEvent");
            }
        },

    },
}
</script>

<style scoped>
div.body-category{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0.24rem 0.16rem 0.3rem;
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
}
div.text-title{

    font-family: SourceHanSerifSC, SourceHanSerifSC, sans-serif;
    font-weight: bold;
    font-size: 0.18rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: left;
}
ul.items-category{
    flex: 1;
    /*background: #F7C2C7;*/
}
div.button-category{
    width: 1.3rem;
    height: 0.45rem;
    background: url("../../../assets/images/List/img-category.png");
    background-size: cover;
    margin: auto;

    font-family: SourceHanSerifSC, SourceHanSerifSC, sans-serif;
    font-weight: bold;
    font-size: 0.15rem;
    color: #000000;
    line-height: 0.45rem;
    text-align: center;
}
ul.items-category{
    overflow-y: auto;
}
li.select-item{
    width: 100%;
    height: 0.2rem;
    margin-top: 0.24rem;
    display: flex;
}
li.select-item:nth-of-type(1){
    margin-top: 0.1rem;
}
div.text-name{
    flex: 1;
    font-family: SourceHanSerifSC, SourceHanSerifSC, sans-serif;
    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    line-height: 0.2rem;
    text-align: left;
}
div.icon-select{
    width: 0.18rem;
    height: 0.19rem;
    background: url("../../../assets/images/List/icon-selected.png");
    background-size: cover;
}

</style>